import { InternalTransferDetailPage } from '@/features/internal-transfer/pages/InternalTransferDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/internal-transfer/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["internal_transfer.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InternalTransferDetailPage,
})
